import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/dashboard' },

  // Chain wallet pages (lazy-loaded)
  { path: '/tron',     name: 'Tron',     component: () => import('../components/HelloWorld.vue') },
  { path: '/solana',   name: 'Solana',   component: () => import('../components/SolanaWallet.vue') },
  { path: '/ethereum', name: 'Ethereum', component: () => import('../components/EthereumWallet.vue') },
  { path: '/bsc',      name: 'Bsc',      component: () => import('../components/BscWallet.vue') },
  { path: '/polygon',  name: 'Polygon',  component: () => import('../components/PolygonWallet.vue') },
  { path: '/bitcoin',  name: 'Bitcoin',  component: () => import('../components/BtcWallet.vue') },

  // Transaction history pages (lazy-loaded)
  { path: '/tron/transactions',     name: 'TronTx',    component: () => import('../views/TronTransactions.vue') },
  { path: '/tron/graph',            name: 'TronGraph', component: () => import('../views/TronGraph.vue') },
  { path: '/solana/transactions',   name: 'SolanaTx',  component: () => import('../views/SolanaTransactions.vue') },
  { path: '/ethereum/transactions', name: 'EthTx',     component: () => import('../views/EthTransactions.vue') },
  { path: '/bsc/transactions',      name: 'BscTx',     component: () => import('../views/BscTransactions.vue') },
  { path: '/polygon/transactions',  name: 'PolygonTx', component: () => import('../views/PolygonTransactions.vue') },
  { path: '/bitcoin/transactions',  name: 'BtcTx',     component: () => import('../views/BtcTransactions.vue') },

  // Payout manager
  { path: '/payout', name: 'Payout', component: () => import('../views/PayoutManager.vue') },

  // Database-backed pages
  { path: '/history',   name: 'History',     component: () => import('../views/TransferHistory.vue') },
  { path: '/addresses', name: 'AddressBook', component: () => import('../views/AddressBook.vue') },

  // Global pages
  { path: '/dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue') },
  { path: '/accounts',  name: 'Accounts',  component: () => import('../views/AccountsManager.vue') },
  { path: '/settings',  name: 'Settings',  component: () => import('../views/Settings.vue') },

  { path: '/login', name: 'Login', component: Login },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
